const SERVER_URL = async () => {
    let baseurl = "https://api.motospar.com";
    return baseurl;
};

export { SERVER_URL };
